import styled from 'styled-components';
import { rem } from 'polished';
import { Flex, FlexItem } from 'core/layout';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyledWrapper = styled.div`
  background-color: ${colors.highlight};
  color: ${colors.subtleText};
  font-size: 1.25rem;
  padding-top: ${rem(65)};

  ${media.tabletSmall`
    font-size: 1rem;
  `};
`;

export const StyledHeader = styled.div`
  background-color: ${colors.background};
  border-bottom: 1px solid ${colors.hairline};
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 201;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${rem(65)};

    & > a {
      display: inline-block;
      transform: translateY(10%);

      svg {
        height: 2rem;
        width: auto;
      }
    }
  }
`;

export const FlexWrapper = Flex.extend`
  min-height: calc(100vh - ${rem(65)});
  padding: 2em 0;
  align-items: center;

  margin: 0 !important;
  & > div:first-child {
    padding: 0 !important;
    position: relative;
    z-index: 1;

    max-width: 75%;

    ${media.site`
      max-width: none;
    `};
  }
`;

export const StyledContentHeader = styled.div`
  h1 {
    color: ${colors.subtleText};
    font-size: 3.5em;
    margin-bottom: 0;
  }

  p {
    margin-top: 0.25em !important;
  }
`;

export const IconCol = FlexItem.extend`
  align-self: stretch;
  display: flex;
  align-items: center;
`;

export const StyledBackgroundIcon = styled.div`
  color: ${colors.hairline};
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);

  svg {
    width: 30rem;
    height: auto;
  }
`;

export const StyledNav = styled.nav`
  & > ul {
    list-style: none;
    padding-left: 0;

    & > li + li {
      margin-top: 0.75em;
    }
  }

  a {
    color: ${colors.secondary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Kluda/styled.js